import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, pairwise, startWith, tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../common/take-until-destroy.decorator';

import { matchIsOnWorkArea } from './navigate';

@Component({
    selector: 'cmps-coaching-detail',
    templateUrl: './coaching-detail.component.html',
    host: {
        class: 'cmps-coaching-detail',
        '[class.cmps-coaching-detail--pillar-one-collapsible]':
            '_pillarOneCollapsible',
    },
})
@TakeUntilDestroy()
export class CoachingDetailComponent implements OnInit {
    // TODO move these to reducer
    /** @private */ _pillarOneCollapsible: boolean;
    /** @private */ _open: boolean;
    /** @private */ _explicitlyToggled: boolean;

    constructor(private readonly _router: Router) {}

    ngOnInit(): void {
        this._router.events
            .pipe(
                filter<NavigationEnd>((e) => e instanceof NavigationEnd),
                map((e) => e.url),
                startWith(this._router.url),
                pairwise(),
                filter((urls) => urls[0] !== urls[1]),
                startWith([null, this._router.url]),
                tap((e) => {
                    this._pillarOneCollapsible = matchIsOnWorkArea(e[1]);
                    if (!this._pillarOneCollapsible) {
                        this._open = false;
                        this._explicitlyToggled = false;
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    /** @private */ _onPillarOneToggleClick(): void {
        this._open = !this._open;
        this._explicitlyToggled = true;
    }
}
